import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { LicensePrePaidSubFormGzDataProvider } from '../dataProvider/LicensePrePaidSubFormGzDataProvider';

export class LicensePrePaidSubFormDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, LicensePrePaidSubFormGzDataProvider);
  }
}
